import { render, staticRenderFns } from "./DailyOverviewListingLipo.vue?vue&type=template&id=2b718366&scoped=true"
import script from "./DailyOverviewListingLipo.vue?vue&type=script&lang=js"
export * from "./DailyOverviewListingLipo.vue?vue&type=script&lang=js"
import style0 from "./DailyOverviewListingLipo.vue?vue&type=style&index=0&id=2b718366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b718366",
  null
  
)

export default component.exports